import constants from '../config/constants'
import { store } from '../store/configStore'
import { getPublicAccessToken, getUserTokens, userLogout } from './auth'
import { setPublicAccessToken } from '../store/reducers/settingsSlice'
import { setTokens } from '../store/reducers/profileSlice'

export const publicRequest = async ({ url, method, headers, data, form_data }) => {  
  const state = store.getState()
    
  const access_token = state.settings.access_token ? state.settings.access_token : await getPublicAccessToken()
  
  let options = {
    method,
    headers: { ...headers }
  }
  
  options.headers['Authorization'] = `Bearer ${access_token}`
  
  if (data) {
    options.headers['Content-Type'] = 'application/json'
    options.body = JSON.stringify(data)
  }

  if (form_data) {
    options.body = form_data
  }
  
  let response = await fetch(url, options)
  
  if (response.status === constants.unAuthorizedStatusCode) {
    const new_access_token = await getPublicAccessToken()

    if (new_access_token) {
        store.dispatch(setPublicAccessToken({ public_access_token: new_access_token }))
        options.headers['Authorization'] = `Bearer ${new_access_token}`
        response = await fetch(url, options)
    }
  }
  
  if (response.ok) {
    const status_code = response.status
    const res_data = await response.json()
    return {status_code: status_code, data: res_data}
  } 

  const res_data = await response.json()
    
  return { 
    status_code: response.status, 
    data: null, 
    error: JSON.stringify(res_data)
  }
}

export const request = async ({ url, method, headers, data, form_data, accessToken }) => {  
  const state = store.getState()
  
  const access_token = accessToken ? accessToken : state.profile.access_token
  const refresh_token = state.profile.refresh_token ? state.profile.refresh_token : ''
  
  let options = {
    method,
    headers: { ...headers }
  }
  
  options.headers['Authorization'] = `Bearer ${access_token}`
  
  if (data) {
    options.headers['Content-Type'] = 'application/json'
    options.body = JSON.stringify(data)
  }

  if (form_data) {
    options.body = form_data
  }
  
  let response = await fetch(url, options)
  
  if (response.status === constants.unAuthorizedStatusCode) {
    const userTokens = await getUserTokens({ grantType: 'refresh_token', refreshToken: refresh_token })

    if (userTokens && userTokens.access_token && userTokens.refresh_token) {
      store.dispatch(setTokens({ access_token: userTokens.access_token, refresh_token: userTokens.refresh_token }))
      options.headers['Authorization'] = `Bearer ${userTokens.access_token}`
      response = await fetch(url, options)
    } else {
      userLogout()
    }
  }
  
  if (response.ok) {
    const status_code = response.status

    if (method === 'DELETE') {
      return { status_code: status_code }
    }

    const res_data = await response.json()
    return { status_code: status_code, data: res_data }
  }

  const res_data = await response.json()
    
  return {
    status_code: response.status, 
    data: null, 
    error: JSON.stringify(res_data)
  }
}

export const checkAccessRequest = async (url) => {    
  let options = { method: 'GET', headers: {} }
  options.headers['Content-Type'] = 'application/json'
  
  try {
    const response = await fetch(url, options)
    
    if (response.ok) {
      const status_code = response.status
      const res_data = await response.json()
      return { status_code, data: res_data }
    } else {
      const status_code = response.status
      const res_data = await response.json()
      return { status_code, data: res_data }
    }
  } catch {
    return { status_code: 404, data: null }
  }
}